var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFourSpace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 25,
  fill: "none",
  viewBox: "0 0 25 25"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "four-space_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.616.183h24v24h-24z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  clipPath: "url(#four-space_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.587,
  height: 8.065,
  x: 6.844,
  y: 13.367,
  rx: 0.989
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.587,
  height: 8.065,
  x: 13.801,
  y: 13.367,
  rx: 0.989
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.587,
  height: 8.065,
  x: 6.844,
  y: 2.933,
  rx: 0.989
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.587,
  height: 8.065,
  x: 13.801,
  y: 2.933,
  rx: 0.989
}))));
export { SvgFourSpace as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI1IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHdpZHRoPSIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJtLjYxNjIxMS4xODI2MTdoMjR2MjRoLTI0eiIvPjwvY2xpcFBhdGg+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiPjxyZWN0IGhlaWdodD0iOC4wNjUyMiIgcng9Ii45ODkxMyIgd2lkdGg9IjQuNTg2OTYiIHg9IjYuODQ0NDgiIHk9IjEzLjM2NzIiLz48cmVjdCBoZWlnaHQ9IjguMDY1MjIiIHJ4PSIuOTg5MTMiIHdpZHRoPSI0LjU4Njk2IiB4PSIxMy44MDEiIHk9IjEzLjM2NzIiLz48cmVjdCBoZWlnaHQ9IjguMDY1MjIiIHJ4PSIuOTg5MTMiIHdpZHRoPSI0LjU4Njk2IiB4PSI2Ljg0NDQ4IiB5PSIyLjkzMjYyIi8+PHJlY3QgaGVpZ2h0PSI4LjA2NTIyIiByeD0iLjk4OTEzIiB3aWR0aD0iNC41ODY5NiIgeD0iMTMuODAxIiB5PSIyLjkzMjYyIi8+PC9nPjwvc3ZnPg==";